var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_switch_off",
    "data-name": "icona switch off",
    transform: "translate(-964 -116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_switch_off-2",
    "data-name": "icona switch off",
    transform: "translate(964 124)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_150",
    "data-name": "Rettangolo 150",
    width: 32,
    height: 16,
    rx: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_24",
    "data-name": "Ellisse 24",
    cx: 6.545,
    cy: 6.545,
    r: 6.545,
    transform: "translate(1.455 1.455)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_778",
    "data-name": "Rettangolo 778",
    transform: "translate(964 116)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOff);
export default __webpack_public_path__ + "static/media/switch_off.be13d6150ffff4cdc1860d21c2c32e0d.svg";
export { ForwardRef as ReactComponent };